import {useEffect, useState} from "react";
import {findClosestBreakpoint} from "../features/breakpoints/utils/breakpointUtils";
import {Breakpoint} from "../features/breakpoints/types/Breakpoint";

export const useMediaBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState<Breakpoint>(findClosestBreakpoint());

  useEffect(() => {
    const listener = () => setBreakpoint(findClosestBreakpoint());
    listener();
    window.addEventListener("resize", listener);
    return () => window.removeEventListener("resize", listener);
  }, []);

  return breakpoint;
};
